import { useLanguage } from '../contexts/LanguageContext';
import pub from '../i18n/publicTranslations';

export function usePublicT() {
  const { language } = useLanguage();
  return (key) => {
    const entry = pub[key];
    if (!entry) return key;
    const idx = language === 'es' ? 1 : language === 'fr' ? 2 : 0;
    return entry[idx] || entry[0];
  };
}
